
function SanitizeInputFunction(input) {

let textoSemAcento = input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
let textoMinusculo = textoSemAcento.toLowerCase();
let sanitizedInput = textoMinusculo.replace(/[^a-z0-9]/g, "");

return sanitizedInput;

}

export default SanitizeInputFunction;